/**
 * 求人票ページ
 */

import { throttle, getCookie, deleteCookie } from './library';

class Job {
    constructor() {
        // JSON-LD作成
        if( document.getElementById('json-ld-url') ){
            this.makeJsonLD();
        }
        
        // お気に入りに追加・削除
        this.addFavoriteBtnEls = document.querySelectorAll('.addFavorite');
        if( this.addFavoriteBtnEls.length > 0 ){
            this.addFavoriteBtnEls.forEach(el => el.addEventListener('click', () => this.toggleFavorite(el)));
        }

        // タブクリックしたらスクロール
        this.tabEl = document.querySelectorAll('a[href*="#"]');
        if( this.tabEl.length > 0 ){
            this.tabEl.forEach(el => el.addEventListener('click', ev => this.scrollLink(el, ev)));
        }

        // ヘッダー表示・非表示
        this.toggleMenuHeader();

        // セクションによってメニュー線色変更
        this.changeTabColor();

        // 応募、気になるボタン表示・非表示
        this.toggleButtons();
    }

    /**
     * JSON-LD作成
     */
    async makeJsonLD() {
        let content1 = document.getElementById('info').innerHTML.replaceAll('"', '\\"');
        let content2 = document.getElementById('recruit').innerHTML.replaceAll('"', '\\"');
        let content3 = document.getElementById('company').innerHTML.replaceAll('"', '\\"');
        content1 = content1.replace(/\s+/g, '');
        content2 = content2.replace(/\s+/g, '');
        content3 = content3.replace(/\s+/g, '');

        const url = document.getElementById('json-ld-url').value;
        let structuredDataText = await fetch(url);
        structuredDataText = await structuredDataText.text();
        structuredDataText = structuredDataText.replace('replace_ld_json_description', content1 + content2 + content3);
        const script = document.createElement('script');
        script.setAttribute('type', 'application/ld+json');
        script.textContent = structuredDataText;
        document.head.appendChild(script);
    }

    /**
     * お気に入りに追加・削除
     */
    async toggleFavorite(el) {
        try{
            const page = document.body.classList.contains('front-job-show') ? 'show' : 'index';
            let url;
            if( page == 'show' ){
                url = !el.classList.contains('added')
                    ? document.getElementById('favorite-store-url').value
                    : document.getElementById('favorite-destroy-url').value;
            }else{
                url = !el.classList.contains('added')
                    ? el.closest('div').querySelector('.favorite-store-url').value
                    : el.closest('div').querySelector('.favorite-destroy-url').value;
            }
            

            const method = !el.classList.contains('added')
                ? 'POST'
                : 'DELETE';

            let res = await fetch(url, {
                method: method,
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    _token: document.querySelector('[name=csrf-token]').content,
                    job_id: el.dataset.jobId,
                    from: 'ajax',
                })
            });

            if( !res.ok ) throw new Error(res.statusText);
            res = await res.json();
            if( res.status == 'error' ) throw new Error(res.message);

            if( !el.classList.contains('added') ){
                if( page == 'show' ){
                    document.querySelectorAll('.addFavorite').forEach(_el => {
                        _el.value = '気になるから削除';
                        _el.classList.add('added');
                    });
                }else{
                    el.value = '気になるから削除';
                    el.classList.add('added');
                }
            }else{
                if( page == 'show' ){
                    document.querySelectorAll('.addFavorite').forEach(_el => {
                        _el.value = '気になるに追加';
                        _el.classList.remove('added');
                    });
                }else{
                    el.value = '気になるに追加';
                    el.classList.remove('added');
                }
            }

        }catch( error ){
            console.error('エラーが発生しました', error);
        }
    }

    /**
     * タブクリックしたらスクロール
     */
    scrollLink(el, ev) {
        ev.preventDefault();
        const targetId = el.href.match(/#(.*)$/)[1];
        document.getElementById(targetId).scrollIntoView({behavior: 'smooth'});
        setTimeout(() => {
            document.querySelector('body > header').style.top = '-113px';
            document.getElementById('scroll-menu').style.top = 0;
        }, 1000)
    }

    /**
     * ヘッダー表示・非表示
     * 下スクロールで非表示、上スクロールで表示
     */
    toggleMenuHeader() {
        let startPosition = 0;
        let windowPosition;
        let headerEl = document.getElementById('scroll-menu');

        if( headerEl ){
            window.addEventListener('scroll',
                throttle(() => {
                    windowPosition = window.scrollY;

                    // 上にスクロールしているのでheaderの高さをプラスする
                    if( startPosition > windowPosition ){
                        headerEl.style.top = null;
                    }
                    // スクロール量が現在位置のほうが大きければ、
                    // 下にスクロールしているのでヘッダートップ固定
                    else{
                        headerEl.style.top = 0;
                    }

                    // 現在の位置を更新する
                    startPosition = windowPosition;
                }, 10)
            );
        }
    }

    /**
     * セクションによってメニュー線色変更
     */
    changeTabColor() {
        window.addEventListener('scroll',
            throttle(() => {
                var scrollMenuItems = document.querySelectorAll('#scroll-menu .tab_item');
                var sections = document.querySelectorAll('.job_info');
                var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
                var windowHeight = window.innerHeight;

                for (var i = 0; i < sections.length; i++) {
                    var section = sections[i];
                    var sectionTop = section.offsetTop;
                    var sectionHeight = section.offsetHeight;

                    if (scrollPosition >= sectionTop - windowHeight / 2 && scrollPosition < sectionTop + sectionHeight - windowHeight / 2) {
                        for (var j = 0; j < scrollMenuItems.length; j++) {
                            scrollMenuItems[j].classList.remove('is_this');
                        }
                        scrollMenuItems[i].classList.add('is_this');
                    }
                }
            }, 100)
        );
    }

    /**
     * 応募、気になるボタン表示・非表示
     */
    toggleButtons() {
        window.addEventListener('scroll',
            throttle(() => {
                const addTarget = document.querySelector('.entry_btn');
                const rangeTarget = document.querySelector('.detail');
                const scroll = window.scrollY;
                const startPos = rangeTarget.offsetTop;
                const endPos = startPos + rangeTarget.offsetHeight;
                if( scroll > startPos && scroll < endPos ){
                    addTarget.classList.add('show');
                }else{
                    addTarget.classList.remove('show');
                }
            }, 10)
        );
    }
}

const job = new Job();
